















import { defineComponent, computed } from '@vue/composition-api'
import AdminOnly from '@/contexts/auth/AdminOnly.vue'
import { useErrorsState } from './errors'

export default defineComponent({
  components: {
    AdminOnly
  },

  setup() {
    const errorsState = useErrorsState()
    const isVisible = computed(() => errorsState.errors.length > 0)

    return {
      isVisible,
      errors: errorsState.errors
    }
  }
})
